// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a860bc82","239":"f47c3e50","453":"04203fd7","455":"3bbb7545"}[chunkId] + ".chunk.js";
};